import { render } from "./DefaultPayrunSetting.vue?vue&type=template&id=69c0e3ed"
import script from "./DefaultPayrunSetting.vue?vue&type=script&lang=js"
export * from "./DefaultPayrunSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__